import SuccessIcon from "shared/icons/status-icons/success-icon.svg?react";
import FailedIcon from "shared/icons/status-icons/fail-icon.svg?react";
import { cx } from "shared/utils";
import { ChevronDown } from "untitledui-js-base";
import { Dispatch } from "react";

interface AccordionControlProps {
  itemId: string;
  itemResult?: boolean;
  isAccordionOpen: { [key: string]: boolean };
  setIsAccordionOpen: Dispatch<
    React.SetStateAction<{
      [key: string]: boolean;
    }>
  >;
}

export const AccordionControl = ({
  itemId,
  itemResult,
  isAccordionOpen,
  setIsAccordionOpen
}: AccordionControlProps) => {
  return (
    <div
      onClick={() =>
        setIsAccordionOpen((prev) => ({
          ...prev,
          [itemId]: !prev[itemId]
        }))
      }
      className={cx(
        "w-[72px] bg-content-1000-inverted py-2.5 px-3.5 flex items-center gap-2 transition-all",
        isAccordionOpen[itemId] ? "rounded-tr-lg" : "rounded-r-lg"
      )}
    >
      <p className="text-content-1000 font-medium text-sm">
        {itemResult ? (
          <SuccessIcon className="w-4 shrink-0 text-primary-500" />
        ) : (
          <FailedIcon className="w-4 shrink-0 text-content-100" />
        )}
      </p>
      <ChevronDown
        className={cx(
          "w-4 shrink-0 text-content-1000 transition-all",
          isAccordionOpen[itemId] ? "rotate-180" : "rotate-0"
        )}
      />
    </div>
  );
};
